import React from "react";
import Footer from "../layout/footer";
import Header from "../layout/header";
import Slider from "../layout/slider";
import ec from "../ec.svg";
import revenue from "../revenue.svg";
import maintain from "../maintain.svg";
const Home = () => {
  return (
    <section>
      <Header />

      <Slider />
      <section class="section-sm bg-counter pt-3 bg2">
        <div class="container">
          <div class="row">
            <div class="offset-lg-2 col-lg-4 text-lg-start">
              <div class="app-title margin-top-50">
                <div class="h3">Encumbrance Certificate-EC</div>
                <p class="font-size-8 text-justify">
                  An Encumbrance Certificate (EC) is a crucial document used as
                  evidence of free title/possession of a property. The document
                  is needed while purchasing or selling a property or when
                  applying for a home loan or loan against property to confirm
                  that the particular property is free of any economic or legal
                  liabilities.
                </p>
              </div>
            </div>
            <div class="col-lg-6">
              <img class="img-fluid h-75" src={ec} alt=""></img>
            </div>
          </div>

          <div class="row">
            <div class="offset-lg-1  col-lg-6">
              <img class="img-fluid h-75" src={revenue} alt=""></img>
            </div>
            <div class="col-lg-4 text-lg-start">
              <div class="app-title margin-top-50">
                <div class="h3">Revenue Documents-Patta</div>
                <p class="font-size-8 text-justify">
                  Land patta is a legal document comprising the details of the
                  owner of the property. Also referred to as ‘Record of Rights’,
                  pattas can be used as evidence in the case of a dispute.
                  Mostly pattas are required at the time of property transfer,
                  and revenue officials of the State are responsible for
                  updating and issuing them.
                </p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="offset-lg-2 col-lg-4 text-lg-start">
              <div class="app-title margin-top-50">
                <div class="h3">History Of Search</div>
                <p class="font-size-8 text-justify">
                  Not just Viewing your Documents.....The Quick search feature
                  will saves all your queries...You can easily find them in a manner
                </p>
              </div>
            </div>
            <div class="col-lg-6">
              <img class="img-fluid h-75" src={maintain} alt=""></img>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </section>
  );
};

export default Home;
